// Shot-breakdown import — display constants.
// Reproduces the source document's row-shading "world" semantics as chip colors.

// Each entry: keyword matchers (lowercase) + Tailwind classes for the chip + the
// left color-bar that runs down a row.
export const WORLD_PALETTE = [
  { key: "soundstage", match: ["soundstage", "founder", "stage"], label: "Founder",
    chip: "bg-amber-500/15 text-amber-300 border-amber-500/30", bar: "bg-amber-500/60" },
  { key: "desk", match: ["desk", "prep", "rehears", "hostel", "apartment"], label: "Desk / Prep",
    chip: "bg-sky-500/15 text-sky-300 border-sky-500/30", bar: "bg-sky-500/60" },
  { key: "threshold", match: ["threshold", "judgment", "judgement", "placement", "interview"], label: "Threshold",
    chip: "bg-rose-500/15 text-rose-300 border-rose-500/30", bar: "bg-rose-500/60" },
  { key: "product", match: ["product", "ui", "screen", "dashboard", "resume"], label: "Product UI",
    chip: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30", bar: "bg-emerald-500/60" },
  { key: "testimonial", match: ["testimonial", "sync", "village", "family", "b-roll", "broll"], label: "Testimonial",
    chip: "bg-stone-400/15 text-stone-300 border-stone-400/30", bar: "bg-stone-400/60" },
];

const WORLD_DEFAULT = {
  key: "other", label: "—",
  chip: "bg-[var(--bg-muted)] text-[var(--text-muted)] border-[var(--border-subtle)]",
  bar: "bg-[var(--border-subtle)]",
};

/** Resolve a free-text world tag to a palette entry (keyword match, else default). */
export function resolveWorld(tag) {
  if (!tag) return WORLD_DEFAULT;
  const t = String(tag).toLowerCase();
  return WORLD_PALETTE.find((w) => w.match.some((m) => t.includes(m))) || WORLD_DEFAULT;
}

export const RENDER_KINDS = [
  { value: "photoreal", label: "Photoreal" },
  { value: "screen_capture", label: "Screen / UI" },
];
